import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Loader from "../../../components/loader/loader";

import Snackbar from "../../../components/snackbar/snackbar";
import { userLogin } from "./auth.api";
import "./login.css";

export default function Login(props) {
  const history = useHistory();
  const [loginParams, setLoginParams] = useState({});
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState(false)

  const verifyUser = (e) => {
    e.preventDefault();
    setIsActive(true);
    setSubmit(true);
    if(!error){
    userLogin(loginParams)
      .then((res) => {
        props.setPhone(loginParams.mobile_number);
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((err) => {
        setSubmit(false);
        setSnackMessage(err.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });} else {
        setSnackMessage("Enter a valid Phone number");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        setSubmit(false);
      }
  };
  
  // const verifyUser = (e) => {
  //   e.preventDefault();
  //   setIsActive(true);
  //   setSubmit(true);
  //   props.setPhone(loginParams.mobile_number);
  //   setSnackOpen(true);
  // };
  const handleChange = (e) => {
    var ticket = e.target.value;
    const sequentialPattern = /(012345|123456|234567|345678|456789|987654|876543|765432|654321|543210|999999|111111111|2222222|33333333|44444444|55555555|6666666666|7777777777|8888888)/;
    const phoneNumberRegex = /^(?!(\d)\1{9})[6-9]\d{9}$/;
    var reg = new RegExp("^[0-9]*$");

    if (e.target.validity.patternMismatch) {
      e.target.setCustomValidity("Please enter valid 10 digit number");
    } else {
      e.target.setCustomValidity("");
    }
console.log(reg.test(ticket) , phoneNumberRegex.test(ticket) , !sequentialPattern.test(ticket))
    if (reg.test(ticket) && phoneNumberRegex.test(ticket) && !sequentialPattern.test(ticket)) {
      setLoginParams({ [e.target.name]: ticket });
      setError(false)
    } else {
      setError(true)
      setLoginParams({ [e.target.name]: ticket });
    }
  };
//   const handleChange = (e) => {
//     var ticket = e.target.value;
//     var reg = new RegExp("^[0-9]*$");
//     const sequentialPattern = /(012345|123456|234567|345678|456789|987654|876543|765432|654321|543210|9999999999|111111111|2222222|33333333|44444444|55555555|6666666666|7777777777|8888888888)/;
//     const phoneNumberRegex = /^(?!(\d)\1{9})[6-9]\d{9}$/;

//     if (e.target.validity.patternMismatch) {
//         e.target.setCustomValidity("Please enter a valid 10-digit number.");
//     } else if (!reg.test(ticket)) {
//         e.target.setCustomValidity("Please enter only digits.");
//     } else if (sequentialPattern.test(ticket)) {
//         e.target.setCustomValidity("Please avoid sequential numbers.");
//     } else if (!phoneNumberRegex.test(ticket)) {
//         e.target.setCustomValidity("Please enter a valid phone number starting with 6, 7, 8, or 9.");
//     } else {
//         e.target.setCustomValidity("");
//         setLoginParams({ [e.target.name]: ticket });
//     }
// };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/otp");
    }
  };
  return (
    <>
      {" "}
      <div className="area">
        {/* <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul> */}
        <Loader open={isActive} />

        <div className="login-container">
          <div className="login-section">
            <div className="">
              <form onSubmit={verifyUser}>
                <div className="login-header">Login</div>
                <div className="login-body d-flex justify-content-center align-items-center flex-column">
                  <div>
                    <img src="/resources/img/login/login-avatar.png" alt="" />
                  </div>
                  <div className="number-label ">
                    Enter your Registered Mobile Number
                  </div>

                  <div className="d-flex">
                    <div className="">
                      <input
                        type="text"
                        value="+91"
                        className="number-prefix"
                        disabled
                      />
                    </div>
                    <div className="">
                      <input
                        type="tel"
                        className="number"
                        name="mobile_number"
                        maxLength="10"
                        minLength="10"
                        pattern="[0-9]{10}"
                        required
                        value={loginParams.mobile_number ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="login-action">
                  <button
                    className="login-button"
                    type="submit"
                    disabled={submit}
                  >
                    Login
                  </button>
                  <div className="d-flex justify-content-end mt-2">
                    <span 
                      className="company-login-link"    
                      onClick={() => history.push('/company-login')}
                      style={{ 
                        cursor: 'pointer', 
                        color: '#007bff', 
                        textDecoration: 'underline',
                        fontSize: '14px',
                      }}
                    >
                      Login as Staff
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <Snackbar
            message={snackMessage}
            error={isSnackError}
            open={snackOpen}
            close={snackbarClose}
          />
        </div>
      </div>
    </>
  );
}
